import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { HomeSelectors } from 'src/app/store';

@Component({
    selector: 'app-statistics',
    templateUrl: './statistics.component.html',
    styleUrls: ['./statistics.component.scss'],
})
export class StatisticsComponent {
    vm$ = this.store
        .select(HomeSelectors.selecteStatisticsVM)
        .pipe(tap((vm) => console.log('vm', vm)));

    today: number = Date.now();

    constructor(private router: Router, private store: Store) {}

    generateLink(sampleTypeId) {
        let url = '/explore/type/' + sampleTypeId;
        this.router.navigate([url]);
    }
}
